/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State

==========================================================================================*/

export default {
	isUserLoggedIn: () => {
		return localStorage.getItem("userInfo") && localStorage.getItem("accessToken");
	},
	userInfo: localStorage.getItem("userInfo"),
	userPermissions: null,
	user_settings: null,
	datetimes: [],
	timezones: [],
	locales: []
};
